import React, { useEffect, useRef, useState } from 'react'

export default function PortfolioReassessmentCompletionDialog({ completing, context, onCancel, onConfirm }) {
    const cancelButtonRef = useRef(null)
    const [acknowledged, setAcknowledged] = useState(false)
    const [limitationsAccepted, setLimitationsAccepted] = useState(false)
    const contextKey = JSON.stringify(context)
    useEffect(() => { setAcknowledged(false); setLimitationsAccepted(false) }, [contextKey])

    useEffect(() => {
        cancelButtonRef.current?.focus()
    }, [])

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape' && !completing) onCancel()
        }
        document.addEventListener('keydown', handleKeyDown)
        return () => document.removeEventListener('keydown', handleKeyDown)
    }, [completing, onCancel])

    return (
        <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="portfolio-reassessment-completion-title"
            className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/50 p-4"
        >
            <div className="w-full max-w-xl max-h-[calc(100dvh-2rem)] overflow-y-auto rounded-2xl bg-white p-6 shadow-xl">
                <p className="text-xs font-semibold uppercase tracking-wide text-blue-700">
                    Portfolio Reassessment Governance
                </p>
                <h2 id="portfolio-reassessment-completion-title" className="mt-1 text-2xl font-bold">
                    Complete Portfolio Reassessment
                </h2>
                <p className="mt-3 text-sm text-slate-600">
                    This will complete and freeze the Portfolio Reassessment. Captured evidence and the Management
                    governance conclusion will become immutable.
                </p>
                <p className="mt-3">Current authority remains unchanged. This action creates no reauthorization request.</p>
                <p className="mt-3">Frozen comparison: {context?.status || 'Unsupported evidence'}</p>
                <ul>{(context?.limitations || []).map((reason, index) => <li key={index}>{typeof reason === 'string' ? reason : typeof reason?.code === 'string' ? reason.code.replaceAll('_', ' ') : 'Additional evidence limitation'}</li>)}</ul>
                <label className="mt-3 block"><input type="checkbox" checked={acknowledged} onChange={e => setAcknowledged(e.target.checked)} /> I considered the frozen evidence available to me.</label>
                {context?.limitations_required && <label className="mt-3 block"><input type="checkbox" checked={limitationsAccepted} onChange={e => setLimitationsAccepted(e.target.checked)} /> I acknowledge the evidence limitations.</label>}
                <div className="mt-6 flex justify-end gap-3">
                    <button
                        ref={cancelButtonRef}
                        type="button"
                        disabled={completing}
                        onClick={onCancel}
                        className="rounded-lg border px-4 py-2 font-semibold disabled:cursor-not-allowed disabled:opacity-60"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        disabled={completing || !context?.supported || !context?.token || !acknowledged || (context?.limitations_required && !limitationsAccepted)}
                        onClick={() => onConfirm({ accepted: true, token: context.token, limitations_acknowledged: limitationsAccepted })}
                        className="rounded-lg bg-blue-700 px-4 py-2 font-semibold text-white disabled:cursor-not-allowed disabled:opacity-60"
                    >
                        {completing ? 'Completing…' : 'Complete and Freeze'}
                    </button>
                </div>
            </div>
        </div>
    )
}
